module.exports = __webpack_public_path__ + "img/119.10.6b0e6b4f.png";